module.exports = __webpack_public_path__ + "static/media/86.75891447.gif";